import { TCaseComment } from "../../../../../../../services/api/instances/casesApi/types";
import { AppButton } from "../../../../../../../shared/components/AppButton";
import { formatDate } from "../../../../../../../shared/utils/formatDate";
import styles from "./styles.module.css";

interface Props {
  comment: TCaseComment;
  handleDeleteComment: (id: string) => void;
}

export const CaseCommentBlock = ({ comment, handleDeleteComment }: Props) => {
  return (
    <div className={styles["case-comment-block"]}>
      <div className={styles["case-comment-block-header"]}>
        <div className={styles["case-comment-meta"]}>
          <div className={styles["comment-author"]}>
            {comment.case_comment_author}
          </div>
          <div className={styles["comment-date"]}>
            {formatDate(comment.case_comment_data)}
          </div>
        </div>
        <AppButton
          buttonType={"outlined"}
          onClick={() => handleDeleteComment(comment.id)}
          className={styles["delete-btn"]}
        >
          Удалить
        </AppButton>
      </div>
      <div className={styles["case-comment"]}>{comment.case_comment}</div>
    </div>
  );
};
